import React, { SVGProps } from 'react'
export const ThirdDefaultRightSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M10 5C7.135 2.973 3.845 2.511 0 2V1c3.916.52 7.523 1.022 10.578 3.184C13.657 6.362 15.766 9.709 16 14.473c.437 8.902-1.148 14.724-4.5 18.027C8.156 35.795 3.579 36 0 36v-1c3.413 0 7.7-.16 10.798-3.212 3.09-3.044 4.631-8.551 4.203-17.266C14.783 10.08 12.841 7.01 10 5Z"
      clipRule="evenodd"
    />
  </svg>
)
